import React from "react";
import { Row, Col } from "react-bootstrap";
import styled from "styled-components";
const Wrapper = styled.div`
  width: 100%;

  background: #2c5283;
  padding-top: 50px;

  .mainContainer {
    height: 100%;
    padding-left: 25px;
  }
  .image {
    width: 100%;
  }
  .title {
    font-size: 110px;
    color: #fff;
    letter-spacing: -4px;
    margin: 0;
    line-height: 0.99;

    font-weight: 700;
    text-align: center;
    padding-bottom: 25px;
  }

  .text {
    font-size: 20px;
    font-weight: 500;
    color: #fff;
    text-align: center;
    padding: 10px 0;
  }
  .title2 {
    font-size: 22px;
    font-weight: 700;
    color: #fff;
  }
  @media only screen and (max-width: 1399px) {
    .textContainer {
      font-size: 85px;
    }
  }
  @media only screen and (max-width: 1199px) {
    .title {
      padding-bottom: 15px;
    }
    .text {
      padding: 6px 0;
    }
  }
  @media only screen and (max-width: 991px) {
    padding-top: 0;
    .textContainer {
      height: 100%;
      width: 80%;
      margin: 0 auto;
    }
    .mainContainer {
      background: #000;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 60px 15px;
    }
    .title {
      font-size: 70px;
    }
    .text {
      font-size: 18px;
    }
    .title2 {
      font-size: 20px;
    }
    .image {
      width: 100%;
    }
  }
  @media only screen and (max-width: 520px) {
    .title {
      font-size: 50px;
    }
    .textContainer {
      height: 100%;
      width: 90%;
      margin: 0 auto;
    }
  }
`;
const CommonSection = ({
  title,
  title2,
  title3,
  text,
  text2,
  img,
  background,
  padding,
  direction,
}) => {
  return (
    <Wrapper style={{ background: background, padding: padding && "0" }}>
      <Row
        className={`align-items-center justify-content-center ${
          direction && "flex-row-reverse"
        }`}
      >
        <Col lg={6} xl={5} xxl={5} className="mx-auto mainContainer">
          <div className="textContainer d-flex justify-content-center align-items-center">
            <div className="d-flex flex-column align-items-center">
              {" "}
              <h1 className="title ">{title}</h1>
              {title2 && <p className=" title2 ">{title2}</p>}
              <p className="text pt-0">{text}</p>
              {title3 && <p className=" title2 pt-3 ">{title3}</p>}
              <p className="text pt-0">{text2}</p>
            </div>
          </div>
        </Col>{" "}
        <Col lg={6} xl={5} className="d-flex justify-content-end">
          <img src={img} alt="#" className="image" />
        </Col>
      </Row>
    </Wrapper>
  );
};
export default CommonSection;
